import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

const RouteWrapper = ({ enabled = false, children }) => {
  // Checks if transfer type is enabled for program
  if (!enabled) {
    return <Navigate to="/transfers" replace />;
  }

  return children;
};

RouteWrapper.propTypes = {
  enabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default RouteWrapper;
